import React from 'react'

const OwnerMonthlyTimesheetOverview = ({timesheets, teachers, students, invoices}) => {
    const [teacherCancellations, setTeacherCancellations] = React.useState(0)
    const [studentCancellations, setStudentCancellations] = React.useState(0)
    const [chargedCancellations, setChargedCancellations] = React.useState(0)
    const [studentRevenueLoss, setStudentRevenueLoss] = React.useState(0)
    const [teacherRevenueLoss, setTeacherRevenueLoss] = React.useState(0)
    const [totalToChargeMMA, setTotalToChargeMMA] = React.useState(0)
    const [totalToChargeLSMA, setTotalToChargeLSMA] = React.useState(0)
    const [totalToChargeTMA, setTotalToChargeTMA] = React.useState(0)
    const [totalToChargeMOR, setTotalToChargeMOR] = React.useState(0)
    const [totalToChargePSMA, setTotalToChargePSMA] = React.useState(0)
    const [totalToChargeTEM, setTotalToChargeTEM] = React.useState(0)
    const [totalPayoutMMA, setTotalPayoutMMA] = React.useState(0)
    const [totalPayoutLSMA, setTotalPayoutLSMA] = React.useState(0)
    const [totalPayoutTMA, setTotalPayoutTMA] = React.useState(0)
    const [totalPayoutMOR, setTotalPayoutMOR] = React.useState(0)
    const [totalPayoutPSMA, setTotalPayoutPSMA] = React.useState(0)
    const [totalPayoutTEM, setTotalPayoutTEM] = React.useState(0)
    const [briPay, setBriPay] = React.useState(0)
    const [courtneyPay, setCourtneyPay] = React.useState(0)
    const [totalLessonsGiven, setTotalLessonsGiven] = React.useState(0)
    const [totalHoursOfLessonsGiven, setTotalHoursOfLessonsGiven] = React.useState(0)
    const [averageNumberOfLessonsTaught, setAverageNumberOfLessonsTaught] = React.useState(0)
    const [studentsTaught, setStudentsTaught] = React.useState(0)
    const [averageLessonHourlyCost, setAverageLessonHourlyCost] = React.useState(0)
    const [averageTeacherPay, setAverageTeacherPay] = React.useState(0)
    const schoolList = ['mma', 'lsma', 'tma', 'mor', 'psma', 'tem']

    React.useEffect(() => {
        if(timesheets.length > 0) {
            generateLossDueToCancellations()
            generateTotalLessonsGiven()
            generateAverageLessonsPerMonth()
        }
        if(students.length > 0 && teachers.length > 0 && invoices.length > 0) {
            generateTotalPayout()
        }
    }, [timesheets])

    React.useEffect(() => {
        if(students.length > 0 && teachers.length > 0 && invoices.length > 0) {
            generateTotalPayout()
            generateTotalBillingAmount()
            generateAverageLessonCost()
            generateAverageTeacherPayRate()
        }
    }, [invoices])

    React.useEffect(() => {
        if(students.length > 0 && teachers.length > 0) {
            generateTotalPayout()
            generateTotalBillingAmount()
        }
    }, [students, teachers])

    const generateLossDueToCancellations = () => {
        let first = 0;
        let second = 0;
        let third = 0;
        let firstLoss = 0;
        let secondLoss = 0;
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j < timesheets[i].families.length; j++) {
                for(let k = 0; k < timesheets[i].families[j].cancellations.length; k++) {
                    if(timesheets[i].families[j].cancellations[k].cancellor === 'student') {
                        let theStudentsName = timesheets[i].families[j].cancellations[k].student
                        first++
                        for(let l = 0; l < timesheets[i].families[j].listOfFamilyStudents.length; l++) {
                            if(timesheets[i].families[j].listOfFamilyStudents[l].studentName === theStudentsName) {
                                //ADDING AN IF STATEMENT BECAUSE I HAVE ADDED A NEW WAY TO STORE STUDENT'S LESSONS RATES, BUT I STILL WANT TO ACCESS OLD DATA
                                if(!timesheets[i].families[j].listOfFamilyStudents[l].allRates) {
                                    firstLoss = firstLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].lessonRate)
                                } else {
                                    let lengthNumber = timesheets[i].families[j].listOfFamilyStudents[l].lessonLength
                                    firstLoss = firstLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].allRates[lengthNumber])
                                }
                            }
                        }
                    } else if (timesheets[i].families[j].cancellations[k].cancellor === 'teacher') {
                        let theStudentsName = timesheets[i].families[j].cancellations[k].student
                        second++
                        for(let l = 0; l < timesheets[i].families[j].listOfFamilyStudents.length; l++) {
                            if(timesheets[i].families[j].listOfFamilyStudents[l].studentName === theStudentsName) {
                                //ADDING AN IF STATEMENT BECAUSE I HAVE ADDED A NEW WAY TO STORE STUDENT'S LESSONS RATES, BUT I STILL WANT TO ACCESS OLD DATA
                                if(!timesheets[i].families[j].listOfFamilyStudents[l].allRates) {
                                    secondLoss = secondLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].lessonRate)
                                } else {
                                    let anotherLengthNumber = timesheets[i].families[j].listOfFamilyStudents[l].lessonLength
                                    secondLoss = secondLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].allRates[anotherLengthNumber])
                                }
                            }
                        }
                    } else if (timesheets[i].families[j].cancellations[k].cancellor === 'student less than 24hrs') {
                        third++
                    }
                }
            }
        }
        setStudentCancellations(first)
        setTeacherCancellations(second)
        setChargedCancellations(third)
        setStudentRevenueLoss(firstLoss)
        setTeacherRevenueLoss(secondLoss)
    }
    const generateAverageLessonCost = () => {
        let totalRevenue = 0
        let totalHoursTaught = 0
        for(let i = 0; i < invoices.length; i++) {
            let currentInvoice = invoices[i]
            for(let i = 0; i < currentInvoice.lessonsToBeBilled.length; i++) {
                let intLength = parseInt(currentInvoice.lessonsToBeBilled[i].lessonLength)
                let lessLength = intLength.toString()
                //console.log(lessLength)
                if(lessLength === '30') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 0.5
                    }
                } else if(lessLength === '45') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 0.75
                    }
                } else if(lessLength === '60') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 1
                    }
                } else if(lessLength === '15') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 0.25
                    }
                }
            }
        }
        setAverageLessonHourlyCost(Math.round((totalRevenue/totalHoursTaught) * 100) / 100)
    }

    const generateAverageTeacherPayRate = () => {
        let totalPay = parseInt(totalPayoutMMA + totalPayoutLSMA + totalPayoutTMA + totalPayoutMOR)
        let payPerHour = ((totalPay / totalHoursOfLessonsGiven) * 100) / 100
        setAverageTeacherPay(Math.round(payPerHour * 100)/100)
    }

    const generateTotalLessonsGiven = () => {
        let lessonCounter = 0
        let hourCounter = 0
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j < timesheets[i].families.length; j++) {
                for(let k = 0; k < timesheets[i].families[j].lessons.length; k++) {
                    hourCounter = hourCounter + timesheets[i].families[j].lessons[k].lessonLength
                    lessonCounter++
                }
            }
        }
        setTotalLessonsGiven(lessonCounter)
        setTotalHoursOfLessonsGiven(hourCounter/60)
    }

    const generateAverageLessonsPerMonth = () => {
        let lessonCounter = 0
        let studentCounter = 0
        let studentHash = {}
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j < timesheets[i].families.length; j++) {
                for(let k = 0; k < timesheets[i].families[j].lessons.length; k++) {
                    let studentName = timesheets[i].families[j].lessons[k].studentName
                    if(studentHash[studentName]) {

                    } else {
                        studentCounter++
                        studentHash[studentName] = true
                    }
                    lessonCounter++
                }
            }
        }
        setStudentsTaught(studentCounter)
        setAverageNumberOfLessonsTaught(Math.round((lessonCounter/studentCounter)*100) / 100)
    }

    const generateTotalBillingAmount = () => {
        for(let j = 0; j < schoolList.length; j++){
            let total = 0
            for(let i = 0; i < invoices.length; i++) {
                if(invoices[i].school === schoolList[j]) {
                    let invoiceWithFamily = invoices[i]
                    //schoolList[j] === 'psma' && console.log(invoices[i])
                    if(invoiceWithFamily.waveCustomerId && invoiceWithFamily.status !== 'Scholarship') {
                        for(let i = 0; i < students.length; i++) {
                            if(invoiceWithFamily.waveCustomerId === students[i].waveCustomerId) {
                                invoiceWithFamily.familyInfo = students[i]
                            }
                        }
                        // let res = await axios.get(`${baseUrl}/family-lookup/${invoiceWithFamily.waveCustomerId}`, myHeader)
                        // invoiceWithFamily.familyInfo = res.data
                        for(let j = 0; j < invoices[i].lessonsToBeBilled.length; j++) {
                            total = Math.floor(parseInt(total) + parseInt(findStudentRate(invoiceWithFamily, invoices[i].lessonsToBeBilled[j], invoices[i].lessonsToBeBilled[j].studentName, invoices[i].lessonsToBeBilled[j].lessonLength)))
                        }
                        for(let j = 0; j < invoices[i].extrasToBeBilled.length; j++) {
                          total = Math.floor(parseInt(total) + parseInt(invoices[i].extrasToBeBilled[j].amount))
                        }
                    }
                }
            }
            if(schoolList[j] === 'mma') {
                setTotalToChargeMMA(total)
            } else if (schoolList[j] === 'lsma') {
                setTotalToChargeLSMA(total)
            } else if (schoolList[j] === 'tma') {
                setTotalToChargeTMA(total)
            } else if (schoolList[j] === 'mor') {
                setTotalToChargeMOR(total)
            } else if (schoolList[j] === 'psma') {
                setTotalToChargePSMA(total)
            } else if (schoolList[j] === 'tem') {
                setTotalToChargeTEM(total)
            }
        }
    }

    const calculateEstimatedPay = (arrayOfSheets) => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < arrayOfSheets.length; i++) {
            let theTimesheet = arrayOfSheets[i]
            for(let i = 0; i < theTimesheet.families.length; i++) {
                let fam = theTimesheet.families[i]
                for(let i = 0; i < fam.lessons.length; i++) {
                    minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
                }
                for(let i = 0; i < fam.cancellations.length; i++) {
                    if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                        minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                    }
                }
                for(let i = 0; i < fam.extras.length; i++) {
                    allExtras = Number(allExtras) + Number(fam.extras[i].amount)
                }
            }
        }
        return `$${((minutesTaught/60) * Number(arrayOfSheets[0].teacherRate)) + allExtras}`
    }

    const calculateEstimatedPayAgain = (theTimesheet) => {
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < theTimesheet.families.length; i++) {
            let fam = theTimesheet.families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        return ((minutesTaught/60) * Number(theTimesheet.teacherRate)) + allExtras
    }

    const ifTheyHaveTurnedInTheirTimesheetCalculatePay = (teacherId) => {
        let found = false
        let arrayOfSheets = []
        for(let i = 0; i < timesheets.length; i++) {
            if(timesheets[i].teacherId === teacherId) {
                found = true
                arrayOfSheets.push(timesheets[i])
            }
        }
        if(!found) {
            return '-'
        } else {
            return calculateEstimatedPay(arrayOfSheets)
        }
    }

    const generateTotalPayout = () => {
        for(let j = 0; j < schoolList.length; j++) {
            let totalForSchool = 0
            for(let i = 0; i < timesheets.length; i++) {
                if(timesheets[i].school === schoolList[j]) {
                    totalForSchool = Math.floor(totalForSchool + parseInt(calculateEstimatedPayAgain(timesheets[i])))
                }
            }
            if(schoolList[j] === 'mma') {
                setTotalPayoutMMA(totalForSchool)
            } else if (schoolList[j] === 'lsma') {
                setTotalPayoutLSMA(totalForSchool)
            } else if (schoolList[j] === 'tma') {
                setTotalPayoutTMA(totalForSchool)
            } else if (schoolList[j] === 'mor') {
                setTotalPayoutMOR(totalForSchool)
            } else if (schoolList[j] === 'psma') {
                setTotalPayoutPSMA(totalForSchool)
            } else if (schoolList[j] === 'tem') {
                setTotalPayoutTEM(totalForSchool)
            }
        }
        //-------------------OLD WAY----------------------
        // for(let j = 0; j < schoolList.length; j++) {
        //     let total = 0
        //     for(let i = 0; i < teachers.length; i++) {
        //         if(teachers[i].School === schoolList[j]) {
        //             let teachersPay = ifTheyHaveTurnedInTheirTimesheetCalculatePay(teachers[i].TeacherID)
        //             if(teachersPay !== '-') {
        //                 let teachersPayNumber = teachersPay.substring(1)
        //                 total = Math.floor(parseInt(total + parseInt(teachersPayNumber)))
        //             }
        //         }
        //     }
        //     if(schoolList[j] === 'mma') {
        //         setTotalPayoutMMA(total)
        //     } else if (schoolList[j] === 'lsma') {
        //         setTotalPayoutLSMA(total)
        //     } else if (schoolList[j] === 'tma') {
        //         setTotalPayoutTMA(total)
        //     } else if (schoolList[j] === 'mor') {
        //         setTotalPayoutMOR(total)
        //     }
        // }
    }

    const findStudentRate = (invoice, lesson, nameOnInvoice, lengthOfLesson) => {
        let found = false
        if(parseInt(lengthOfLesson) === 31 || parseInt(lengthOfLesson) === 46 || parseInt(lengthOfLesson) === 61 || parseInt(lengthOfLesson) === 32 || parseInt(lengthOfLesson) === 47 || parseInt(lengthOfLesson) === 62) {
          found = true
          if(parseInt(lengthOfLesson) === 31) {
            return 25
          } else if (parseInt(lengthOfLesson) === 46) {
            return 35
          } else if (parseInt(lengthOfLesson) === 61) {
            return 45
          } else if (parseInt(lengthOfLesson) === 32) {
            return 0
        } else if (parseInt(lengthOfLesson) === 47) {
            return 0
        }
        else if (parseInt(lengthOfLesson) === 62) {
            return 0
        }
        } else {
          if(lesson.studentAllRates) {
            return lesson.studentAllRates[lengthOfLesson]
          } else {
          //-----------THIS IS GOING OFF OF WHAT THE STUDENTS RATE WAS BASED OFF OF REAL TIME DATABASE RATE
            for(let i = 0; i < invoice.familyInfo.students.length; i++) {
              if(invoice.familyInfo.students[i].studentName === nameOnInvoice) {
                  found = true
                  if(!invoice.familyInfo.students[i].allRates) {
                    return invoice.familyInfo.students[i].lessonRate
                  } else {
                    return invoice.familyInfo.students[i].allRates[lengthOfLesson]
                  }
              }
          }
          }
        }
        if(!found) {
            console.log('oooooh no!')
            //alert('Student does not exist in the database. Either change student name or go to Student Database and add student to family.')
            return 0
        }
      }


    return(
        <div className="top-billing-box-wrapper">
        <div className="top-billing-each-type-of-cancellation">
            <div className="type-of-cancellation-title">{studentCancellations} Student Cancellations</div>
            <div className="amount-of-loss-per-cancellation"><strong className="amount-of-loss-dollars">-${studentRevenueLoss}</strong> USD</div>
        </div>
        <div className="top-billing-each-type-of-cancellation">
            <div className="type-of-cancellation-title">{teacherCancellations} Teacher Canellations</div>
            <div className="amount-of-loss-per-cancellation"><strong className="amount-of-loss-dollars">-${teacherRevenueLoss}</strong> USD</div>
        </div>
        <div className="top-billing-each-type-of-cancellation">
            <div className="type-of-cancellation-title">Short Notice Cancellations</div>
            <div className="amount-of-loss-per-cancellation"><strong className="amount-of-loss-dollars">{chargedCancellations}</strong></div>
        </div>
        <div className="total-revenue-box">
            <h3 className="total-review-box__income">MMA: ${totalToChargeMMA} | LSMA: ${totalToChargeLSMA} | TSMA: ${totalToChargeTMA} | MOR: ${totalToChargeMOR} | PSMA: ${totalToChargePSMA} | TEM: ${totalToChargeTEM} | Total: ${parseInt(totalToChargeMMA + totalToChargeLSMA + totalToChargeTMA + totalToChargeMOR + totalToChargePSMA + totalToChargeTEM)}</h3>
            <h3 className="total-review-box__payout">MMA: -${totalPayoutMMA} | LSMA: -${totalPayoutLSMA} | TSMA: -${totalPayoutTMA} | MOR: -${totalPayoutMOR} | PSMA: -${totalPayoutPSMA} | TEM: ${totalPayoutTEM} | Total: -${parseInt(totalPayoutMMA + totalPayoutLSMA + totalPayoutTMA + totalPayoutMOR + totalPayoutPSMA + totalPayoutTEM)}</h3>
            <h3 className="total-review-box__profit">MMA: ${parseInt(totalToChargeMMA - totalPayoutMMA)} | LSMA: ${parseInt(totalToChargeLSMA - totalPayoutLSMA)} | TSMA: ${parseInt(totalToChargeTMA - totalPayoutTMA)} | MOR: ${parseInt(totalToChargeMOR - totalPayoutMOR)} | PSMA: ${parseInt(totalToChargePSMA - totalPayoutPSMA)} | TEM: ${parseInt(totalToChargeTEM - totalPayoutTEM)} Estimated Profit: ${parseInt(parseInt(totalToChargeMMA + totalToChargeLSMA + totalToChargeTMA + totalToChargeMOR + totalToChargePSMA + totalToChargeTEM) - parseInt(totalPayoutMMA + totalPayoutLSMA + totalPayoutTMA + totalPayoutMOR + totalPayoutPSMA + totalPayoutTEM) - courtneyPay - briPay)}</h3>
            <div className="employee-pay__inputs">Bri: <input value={briPay} onChange={(e) => setBriPay(e.target.value)} /></div>
            <div className="employee-pay__inputs">Courtney: <input value={courtneyPay} onChange={(e) => setCourtneyPay(e.target.value)} /></div>
        </div>
        <div># of Lessons: {totalLessonsGiven}</div>
        <div>Hours Taught: {totalHoursOfLessonsGiven}</div>
        <div>Average Lesson Length: {Math.round(((totalHoursOfLessonsGiven * 60)/totalLessonsGiven) * 100) /100} minutes</div>
        <div>Students: {studentsTaught}</div>
        <div>Average Lessons Taught Per Student: {averageNumberOfLessonsTaught}</div>
        <div>Average Hourly Lesson Rate: {averageLessonHourlyCost}</div>
        <div>Average Teacher Hourly Rate: {averageTeacherPay}</div>
    </div>
    )
}
export default OwnerMonthlyTimesheetOverview;